import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
  NgModuleRef,
  InjectionToken,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { CountriesApiClient, RegionsApiClient } from './services';
import { CountriesApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    countriesApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    countriesApiConfig: CountriesApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('CountriesApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [CountriesApiClient, RegionsApiClient],
})
export class CountriesApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => CountriesApiConfig
  ): ModuleWithProviders<CountriesApiModule> {
    return {
      ngModule: CountriesApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: CountriesApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CountriesApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => CountriesApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new CountriesApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('countriesApiConfig')));
    cfgMgr.addApiConfig('countriesApiConfig', config);
  }
}
